export const campaignConstants = {
  CAMPAIGN_LOAD: '[Campaign] Load',
  CAMPAIGN_LOAD_SUCCESS: '[Campaign] Load success',
  CAMPAIGN_LOAD_FAILURE: '[Campaign] Load failure',
  CAMPAIGN_RESET: '[Campaign] Reset',
  CAMPAIGN_SAVE: '[Campaign] Save',
  CAMPAIGN_SAVE_SUCCESS: '[Campaign] Save success',
  CAMPAIGN_SAVE_FAILURE: '[Campaign] Save failure',
  CAMPAIGN_DELETE: '[Campaign] Delete',
  CAMPAIGN_DELETE_SUCCESS: '[Campaign] Delete success',
  CAMPAIGN_DELETE_FAILURE: '[Campaign] Delete failure',
  CAMPAIGN_BACK_TO_DRAFT: '[Campaign] Back to draft',
  CAMPAIGN_BACK_TO_DRAFT_SUCCESS: '[Campaign] Back to draft success',
  CAMPAIGN_BACK_TO_DRAFT_FAILURE: '[Campaign] Back to draft failure'
}
